<template>
  <div class="sidebar-header" :class="$route.meta.sidebarheaderClass">
    <div class="sidebar-logo">
      <router-link :to="{name:'index'}">
        <img
          class="img-fluid logo-dark"
          src="@/assets/img/new_logo.png"
          alt=""
        />
      </router-link>

      <router-link :to="{name:'index'}">
        <img
          src="@/assets/img/logo-small.png"
          class="img-fluid logo-small"
          alt=""
        />
      </router-link>
    </div>
  </div>
</template>
